var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportiveCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191.817,
    height: 221.026,
    viewBox: "0 0 191.817 221.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3602",
    "data-name": "Rectangle 3602",
    width: 191.817,
    height: 221.026,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22465",
    "data-name": "Group 22465",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12002",
    "data-name": "Path 12002",
    d: "M0,1471.443.768,1483.5l20.587-1.316-.772-12.059Z",
    transform: "translate(0 -1262.474)",
    fill: "#b0c2e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12003",
    "data-name": "Path 12003",
    d: "M1094.762,598.139l20.583-1.308.382,6.03-20.575,1.308Z",
    transform: "translate(-940.13 -512.53)",
    fill: "#b0c2e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12004",
    "data-name": "Path 12004",
    d: "M1211.357,724.9l.382,6.034-6.517.41Z",
    transform: "translate(-1034.988 -622.505)",
    fill: "#9db2d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12005",
    "data-name": "Path 12005",
    d: "M1111.355,535.2l-16.593,8.89,20.583-1.308,16.6-8.89Z",
    transform: "translate(-940.13 -458.481)",
    fill: "#9db2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12006",
    "data-name": "Path 12006",
    d: "M71.571,973.272,0,1043.644l20.584-1.316,71.571-70.364Z",
    transform: "translate(0 -834.676)",
    fill: "#9db2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12007",
    "data-name": "Path 12007",
    d: "M734.961,694.627l51.211-53.8,20.575-1.308-60.174,63.217Z",
    transform: "translate(-631.15 -549.189)",
    fill: "#9db2d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12008",
    "data-name": "Path 12008",
    d: "M145.727,1042.328,217.3,971.964l.768,12.067L146.5,1054.387Z",
    transform: "translate(-125.144 -834.676)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12009",
    "data-name": "Path 12009",
    d: "M817.174,702.736l60.174-63.217.772,12.059L817.946,714.8Z",
    transform: "translate(-701.751 -549.188)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12010",
    "data-name": "Path 12010",
    d: "M652.433,971.964l23.269,16.26.772,12.059L653.2,984.031Z",
    transform: "translate(-560.279 -834.676)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12011",
    "data-name": "Path 12011",
    d: "M594.47,1066.2l11.637,8.768,20.592-1.316L603.425,1057.4Z",
    transform: "translate(-510.503 -908.043)",
    fill: "#9db2d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12012",
    "data-name": "Path 12012",
    d: "M1240.487,542.782l1.536,24.122,15.066-33.012Z",
    transform: "translate(-1065.272 -458.481)",
    fill: "#d2e4fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22464",
    "data-name": "Group 22464",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22463",
    "data-name": "Group 22463",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12013",
    "data-name": "Path 12013",
    d: "M665.033,353.179a45.239,45.239,0,0,1,1.914-4.417,9.87,9.87,0,0,1,2.763-1.877c.179.081.244.264.033.622s-1.105,1.385-.927,1.406,3.007-2.791,3.681-2.385.691,2.994-.236,4.546-4.66,3.328-4.851,3.568c-1.633,2.015-2.377-1.463-2.377-1.463",
    transform: "translate(-571.099 -297.547)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12014",
    "data-name": "Path 12014",
    d: "M482.162,384.505c-1.272-.865-1.528-.829-1.528-.829s-10.5,10.434-11.523,11.368-18.613,9.686-18.613,9.686l-.345,14.29s21.7-15.732,24.26-18.154c4.221-4,9.166-14.729,9.166-14.729a4.332,4.332,0,0,0-1.418-1.633",
    transform: "translate(-386.57 -329.483)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12015",
    "data-name": "Path 12015",
    d: "M274.085,1194.034a37.4,37.4,0,0,1-3.75,3.632c-.748.406.333,5.111,2.369,5.42a1.877,1.877,0,0,0,1.784-.918l-.325-1.365,4.286-3.836Z",
    transform: "translate(-231.947 -1025.38)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12016",
    "data-name": "Path 12016",
    d: "M602.525,1198.761a36,36,0,0,1,.158,5.12c-.215.812,4.067,3.152,5.7,1.885a1.8,1.8,0,0,0,.524-1.9l-1.239-.667.057-5.656Z",
    transform: "translate(-517.42 -1028.393)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12017",
    "data-name": "Path 12017",
    d: "M880.4,761.8a37.781,37.781,0,0,0,1.04,5.432c.406.8-3.543,4.266-5.558,3.323a1.973,1.973,0,0,1-1.008-1.893l1.154-.983-1.382-5.94Z",
    transform: "translate(-751.106 -654.15)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12018",
    "data-name": "Path 12018",
    d: "M593.618,1241.038a27.831,27.831,0,0,0,3.14.276,26.294,26.294,0,0,0,2.808-.244s2.617.829,3.445,1.187c1.845.8,3.9,1.69,4.445,2.56.171.276-.252,1.081-.894,1.389-2.722,1.268-12.193,1.528-13.928.91-2-.7.983-6.078.983-6.078",
    transform: "translate(-508.335 -1065.745)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12019",
    "data-name": "Path 12019",
    d: "M838.927,799.139a29.7,29.7,0,0,1-3.234,1.032c-1.381.276-3.015.406-3.015.406s-2.56,1.479-3.348,2.048c-1.747,1.284-3.714,2.7-4.079,3.738-.122.333.512,1.072,1.267,1.251,3.161.7,13.189-1.251,14.879-2.3,1.934-1.211-2.47-6.176-2.47-6.176",
    transform: "translate(-708.673 -686.263)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12020",
    "data-name": "Path 12020",
    d: "M405.551,846.477c-.679-.342-1.3-.634-1.9-.91-2.125,2.438-4.53,5.168-7,7.988l5.375,11.255c-.605-.683,16.939,9.987,16.939,9.987s3.986,14.245,5.485,23.289a15.522,15.522,0,0,0,7-.455c.731-10.653-.922-27.141-2.21-29.2-.743-1.186-15.635-18.007-23.692-21.956",
    transform: "translate(-340.624 -726.133)",
    fill: "#20386f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12021",
    "data-name": "Path 12021",
    d: "M894.024,376.278c.723-.358,1.4-.674,2.048-.971,2.283,2.621,4.721,3.494,7.378,6.538l-4.291,7.464c.65-.731-19.608,17.512-19.608,17.512s-4.3,15.358-5.908,25.114c-3.316.394-3.99.284-7.558-.492-.8-11.486.992-29.266,2.381-31.476.8-1.28,16.862-19.43,25.556-23.688",
    transform: "translate(-743.585 -322.296)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12022",
    "data-name": "Path 12022",
    d: "M289.871,817.089c.609,9.223,4.047,22.347,3.913,23.631-.524,1.707-9.459,17.479-11.133,19.779a10.37,10.37,0,0,0,5.505,3.9c.439.105,15.529-18.706,16.366-20.218.947-1.715,2.523-11.035,2.556-22.583l.435-11.434c-3.726-3.665-9.8-6.1-11.88-5.7-3.612.7-5.916,10.3-5.761,12.628",
    transform: "translate(-242.727 -690.797)",
    fill: "#1d417f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12023",
    "data-name": "Path 12023",
    d: "M240.773,1218.945a26.758,26.758,0,0,0,1.873,2.454,23.273,23.273,0,0,0,2.052,1.869s1.113,2.471,1.394,3.316c.621,1.885,1.32,4.161,1.032,5.144a1.219,1.219,0,0,1-1.552.545c-2.539-1.438-9.329-8.191-10.024-9.865-.8-1.934,5.225-3.462,5.225-3.462",
    transform: "translate(-202.215 -1046.773)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12024",
    "data-name": "Path 12024",
    d: "M708.5,385.368a46.292,46.292,0,0,1,1.227-4.957,10.411,10.411,0,0,1,2.552-2.45c.2.053.3.235.154.642-.163.41-.918,1.646-.723,1.633s2.649-3.445,3.429-3.145,1.251,3.011.553,4.8-4.283,4.3-4.445,4.587c-1.349,2.4-2.746-1.109-2.746-1.109",
    transform: "translate(-608.424 -323.813)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12025",
    "data-name": "Path 12025",
    d: "M418.482,464.568s4.026,4.778,9.158,2.783a15.579,15.579,0,0,0,1.121-4.64c0-.244,0-.48.008-.7.025-2.214.1-3.458.1-3.458h0c-.236-.1-7.846-3.226-7.838-2.966.13,5.993-2.548,8.983-2.548,8.983",
    transform: "translate(-359.373 -391.222)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12026",
    "data-name": "Path 12026",
    d: "M441.895,465.461a11.88,11.88,0,0,0,6.976,4.994c.024-2.214.1-3.458.1-3.458h0c-.211-.057-7.293-1.938-7.074-1.536",
    transform: "translate(-379.474 -399.667)",
    fill: "#ed985f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12027",
    "data-name": "Path 12027",
    d: "M436.266,389.272s-8.561,2.011-9.731-3.336-3.064-8.695,2.352-10.206,6.927.3,7.752,1.991,1.824,10.889-.374,11.551",
    transform: "translate(-365.175 -322.175)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12028",
    "data-name": "Path 12028",
    d: "M400.32,354.633c-.118.077-1.958.642-5.449-6.306a6.048,6.048,0,0,1,.357-5.534c3.543-5.79,9.8-1.93,16.293-5.773,2.336,8.926-4.721,8.155-6.07,8.581s-1.833,2.556-1.934,3.242-.26,1.247-1.958.642-.768,2.405-.5,2.986c0,0,.232,1.54-.744,2.162",
    transform: "translate(-338.663 -289.417)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12029",
    "data-name": "Path 12029",
    d: "M363.856,523.494c-.049,2.836-.215,6.021-.439,9.256-.012.2-.024.386-.037.577-.142,2.007-.3,4.014-.475,5.977q-.11,1.182-.224,2.32l-.012.114c-.008.276-.045.585-.073.878-.723,7.329-1.479,13.132-1.621,13.221a.815.815,0,0,1-.565.147c-1.922-.244-7.667.187-12.368-.829a35.818,35.818,0,0,1-11-4.559c-.483-.292-1.581-1.04-1.491-1.6.089-.626.252-1.52.455-2.641a141.75,141.75,0,0,0,2.365-18.475c.081-1.467.2-2.913.357-4.335a65.4,65.4,0,0,1,1.918-10.344c1.609-5.8,3.982-10.251,6.952-11.986.39-.219,2.478,1.109,4.4,2.34a8.468,8.468,0,0,0,5.457,1.292l1.593,1.767a17.853,17.853,0,0,1,4.559,9.5c.041.313.077.646.11,1a63.8,63.8,0,0,1,.146,6.383",
    transform: "translate(-288.149 -430.397)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12030",
    "data-name": "Path 12030",
    d: "M455.929,600.49c-.049,2.836-.215,6.021-.439,9.256-.012.195-.024.386-.037.577-11-6.879-12.693-19.474-12.693-19.474a30.073,30.073,0,0,1,13.022,3.259,63.8,63.8,0,0,1,.146,6.383",
    transform: "translate(-380.221 -507.393)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12031",
    "data-name": "Path 12031",
    d: "M461.747,427.249c-1.219-1.089-1.95-.585-1.95-.585s-12.518,11.271-13.733,12.112-18.5,2.706-18.5,2.706-6.948.463-8.354,4.161a7.121,7.121,0,0,0,1.682,7.638,7.21,7.21,0,0,0,7.886,1.877c6.208-2.353,18.548-7.127,20.8-8.76,5.01-3.628,13.5-17.223,13.5-17.223a5.147,5.147,0,0,0-1.333-1.926",
    transform: "translate(-359.577 -366.299)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12038",
    "data-name": "Path 12038",
    d: "M700.351,238.394c.943-1.081,4.193-6.541,4.193-6.541l9.638,3.425s-7.566,8.882-9.1,10.592c-3.405,1.658-16.529,5.936-17.8,6.477a6.922,6.922,0,0,0-2.032,1.219c-1.154,1.138-1.56,1.723-2.649,2.856-1.243,1.28-5.335-2.417-4.953-3.754.264-.926,2.564-1.889,4.392-2.7.821-.354,17.455-10.613,18.308-11.576",
    transform: "translate(-581.913 -199.105)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12039",
    "data-name": "Path 12039",
    d: "M869.858,135.488c1.9,1.93,2.625,4.355-1.479,10.751a74.864,74.864,0,0,1-8.175,10.609s-7.119-2.361-9.662-6.988c0,0,12.725-20.961,19.315-14.371",
    transform: "translate(-730.406 -115.25)",
    fill: "#262d4e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12040",
    "data-name": "Path 12040",
    d: "M1052.949,375.64q-17.991-2.035-12.368,16.1,18.82-4,12.368-16.1",
    transform: "translate(-892.451 -322.406)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12041",
    "data-name": "Path 12041",
    d: "M863.126,14.53a18.106,18.106,0,0,1,1.227-3.511,9.413,9.413,0,0,0-.1-7.423A5.842,5.842,0,0,0,858.714,0c-1.447,0-6.436,1.463-7.874,2.763s1.243,7.415,1.243,7.415l4.079,4.14Z",
    transform: "translate(-730.297 -0.001)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12042",
    "data-name": "Path 12042",
    d: "M1073.195,693.941l-5.566.691s-3.836-2.324-8.882-5.461c1.406-1.65,2.934-3.218,4.469-4.807,4.307,3.734,6.55,5.225,9.979,9.577",
    transform: "translate(-909.201 -587.7)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12043",
    "data-name": "Path 12043",
    d: "M1060.238,745.287a10.948,10.948,0,0,0,2.925.24c.7-.2,1.528-1.142,2.284-.711s2.2,4.368,2.031,5.266c-.187.947-.788,2.011-1.5,2.206s-12.034,1.3-14.042.959-2.844-2.356-.8-3.425,7.98-5.164,9.1-4.534",
    transform: "translate(-901.657 -639.518)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12044",
    "data-name": "Path 12044",
    d: "M878.689,369.928s-32.058,21.4-30.5,25.983c3.649,10.718,35.7,27.844,35.7,27.844l4.209-4.969-23.281-23.1s14.578-9.044,15.472-10.67c.91-1.629-1.6-15.09-1.6-15.09",
    transform: "translate(-728.339 -317.677)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12045",
    "data-name": "Path 12045",
    d: "M905.82,133.444c-.081.142-1.268,8,.764,12.815,3.73,8.8,12.644,22.335,14.465,22.359,14.578.191,18.625-4.238,18.625-4.238s-13.262-26.146-18.137-31.537c-2.024-2.235-4.226-4.018-7.314-3.62-.715.081-6.542.865-8.4,4.221",
    transform: "translate(-777.517 -110.923)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12046",
    "data-name": "Path 12046",
    d: "M901.919,79.428l.975,5.639s.309,1.569,1.235,1.946c1.609.666,4.989-5.981,4.989-5.981l-3.007-8.455Z",
    transform: "translate(-774.526 -62.327)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12047",
    "data-name": "Path 12047",
    d: "M907.021,75.122a8.787,8.787,0,0,1-4.6,7.2l-.5-2.893,4.193-6.85Z",
    transform: "translate(-774.525 -62.328)",
    fill: "#ed985f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12048",
    "data-name": "Path 12048",
    d: "M864.531,16.482a4.573,4.573,0,0,0-5,4.92,33.939,33.939,0,0,0,.642,4.356c.845,3.913,3.738,7.236,5.51,6.818s6.062-4.075,4.957-9.646c-.7-3.441-3.12-6.143-6.111-6.448",
    transform: "translate(-738.113 -14.134)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12049",
    "data-name": "Path 12049",
    d: "M929.425,56.091a1.329,1.329,0,1,0,.91-1.849,1.453,1.453,0,0,0-.91,1.849",
    transform: "translate(-798.099 -46.555)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12050",
    "data-name": "Path 12050",
    d: "M843.874,10.261a14.2,14.2,0,0,0-.828-3.649c-.667-1.7-2.828-3.758-4.729-3.608-1.885.146-5.851,2.019-6.721,1.044s-.837-.874-1.064-.991c-.536-.285-2.552,2.1-1.585,5.05s3.567,2.088,4.1,2.024,4.616-3.352,6.062-3.669,4.762,3.8,4.762,3.8",
    transform: "translate(-711.638 -2.574)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12051",
    "data-name": "Path 12051",
    d: "M860.978,258.207c.227-1.414.1-7.769.1-7.769l9.987-2.19s-1.715,11.535-2.113,13.8c-2.024,3.21-10.9,13.786-11.677,14.911a7.016,7.016,0,0,0-1.081,2.109c-.382,1.572-.414,2.287-.739,3.827-.374,1.743-5.8.768-6.192-.569-.26-.918,1.178-2.958,2.308-4.607.512-.74,9.2-18.243,9.41-19.511",
    transform: "translate(-729.278 -213.185)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12052",
    "data-name": "Path 12052",
    d: "M930.362,129.787c2.649.622,4.534,2.308,4.437,9.9a74.427,74.427,0,0,1-1.325,13.331s-7.289,1.763-11.888-.821c0,0-.292-24.52,8.776-22.412",
    transform: "translate(-791.413 -111.345)",
    fill: "#262d4e",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportiveCommunity);
export default __webpack_public_path__ + "static/media/supportive-community.ac2093cb2df3ed901d7c961e52d18444.svg";
export { ForwardRef as ReactComponent };